import React from "react";
import ReactDOM from "react-dom";
import AccordionContainer from "./AccordionContainer";

const initAccordionRT = () => {
  const accordion_blocks = document.getElementsByClassName("rt_accordion");
  console.log(
    "Found " + accordion_blocks.length + " accordions",
    accordion_blocks,
  );
  for (var i = 0; i < accordion_blocks.length; i++) {
    const rootElement = accordion_blocks[i];
    // const accordionUrl =
    //   process.env.NODE_ENV === 'production'
    //     ? rootElement.getAttribute('data-accordion-url')
    //     : process.env.ACCORDION_URL;

    const accordionUrl = rootElement.getAttribute("data-accordion-url");

    ReactDOM.createRoot(rootElement).render(
      <AccordionContainer dataUrl={accordionUrl} />,
    );
  }
};
export default initAccordionRT;
